import { AgResourceLanguage } from '../types';
import { quiz as EnUsQuiz } from '../en-us/quiz';

export const quiz: AgResourceLanguage['quiz'] = {
  ...EnUsQuiz,
  landing: {
    ...EnUsQuiz.landing,
    headline: 'Ontdek of AG1 geschikt is voor jou',
    body: 'Het perfecte dieet bestaat niet, en het zou niet overweldigend moeten zijn om het juiste supplement te vinden om je dagelijkse voedingsbehoeften te ondersteunen. Klik verder om te leren hoe AG1 jou kan ondersteunen in je gezondheidsreis.',
    bodySubtext: '',
    caption: 'Deze tool is niet bedoeld om een aandoening te diagnosticeren of te behandelen',
    start: 'Begin Nu'
  },
  chart: {
    ...EnUsQuiz.chart,
    title: 'Begin met je gratis AG1 Welkomstpakket**',
    subtitle:
      'AG1 biedt 75 vitamines, probiotica en ingrediënten uit volle voedingsmiddelen om de basis te leggen voor mentale en fysieke gezondheid zonder in te boeten op kwaliteit.*'
  },
  tooltip: {
    title: 'WIST JE DAT?'
  },
  ensureModal: {
    title: 'Nog steeds niet zeker?',
    subtitle: 'Bekijk wat anderen zeggen over de voordelen van AG1',
    reviews: 'Lees Beoordelingen',
    reject: 'Nee, bedankt'
  },
  processModal: {
    title: 'Ontvang de laatste informatie',
    subtitle:
      'Wanneer je je aanmeldt voor AG1-nieuws krijg je toegang tot de beste tips, deskundig advies en de nieuwste informatie over gezondheid.',
    signUpText: 'Meld je nu aan',
    signUpSuccess: 'Bedankt, je bent ingeschreven!',
    signUpReject: 'Nee, bedankt'
  },
  policy: {
    title:
      'Door je e-mailadres in te voeren ga je akkoord met het ontvangen van marketingcommunicatie van Athletic Greens en deze informatie wordt verwerkt volgens ons',
    button: 'Privacybeleid'
  },
  valueChart: {
    title: 'Voel de kracht van Eén',
    subtitle:
      'AG1 combineert 75 hoogwaardige ingrediënten in één krachtige schep, waardoor de noodzaak voor enkelvoudige supplementen vervalt.',
    tableHead1: 'AG1 kan vervangen:',
    tableHead2: 'Kosten per maand',
    chartConfig: [
      { title: 'Multivitaminen & mineralen', value: 45 },
      { title: 'Probioticum', value: 30 },
      { title: 'Superfoods', value: 50 },
      { title: 'Stress-adaptogeen', value: 30 },
      { title: 'Immuunondersteuning', value: 40 },
      { title: 'Cognitieve ondersteuning', value: 30 }
    ],
    tableFooter: 'Totaal per maand',
    caption:
      'Gebaseerd op de momenteel beschikbare gegevens over gemiddelde prijzen van premium supplementen in de industrie',
    buttonText: 'Ga Verder'
  },
  results: {
    button: 'Probeer AG1 Nu'
  }
};
